import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import PowerOffIcon from "@mui/icons-material/PowerOff";
import PeopleIcon from "@mui/icons-material/People";
import EventIcon from "@mui/icons-material/Event";
import AddTaskIcon from "@mui/icons-material/AddTask";
import StorageIcon from "@mui/icons-material/Storage";
import SwapVerticalCircleIcon from "@mui/icons-material/SwapVerticalCircle";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCardInformes";
import fetchData from "verticales/FetchData";
// Componentes personalizados
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Otros importsimport fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import ViewClientes from "./Views/viewclientes.js";
import ViewAutoScaling from "./Views/viewautoscaling.js";
import ViewConcurrencia from "./Views/viewconcurrencia.js";
import ViewEc2Agentes from "./Views/viewec2agentes.js";
import { Padding } from "@mui/icons-material";
// URL y contexto para las solicitudes
const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "ec2-get-agente";

const initialCardData = [
  {
    title: "extraccion-faltantes",
    subtitle: "Informe clientes faltantes",
    action: "clientes-extraccion",
    data: [],
    type: "table",
    icon: <PeopleIcon />,
  },
  {
    title: "Agente CPU RAM",
    subtitle: "Instancias con metricas de cpu y ram",
    action: "ec2agentes",
    data: [],
    type: "table",
    icon: <AddTaskIcon />,
  },
  {
    title: "Agente Usuarios",
    subtitle: "Instancias para agente de usuarios conectados",
    action: "ec2agentes",
    data: [],
    type: "table",
    icon: <AddTaskIcon />,
  },
  {
    title: "Agente Procesos",
    subtitle: "Instancias para agente de procesos",
    action: "ec2agentes",
    data: [],
    type: "table",
    icon: <AddTaskIcon />,
  },
  {
    title: "Agente Discos",
    subtitle: "Agente para calcular tamaño de discos",
    action: "ec2agentes",
    data: [],
    type: "table",
    icon: <AddTaskIcon />,
  },
  {
    title: "Agente Monitor de servicios",
    subtitle: "Agente para subir servicios de erp y aws",
    action: "ec2agentes",
    data: [],
    type: "table",
    icon: <AddTaskIcon />,
  },
  {
    title: "Agente TsPlus",
    subtitle: "Agente para subir RDP de TsPlus",
    action: "ec2agentes",
    data: [],
    type: "table",
    icon: <AddTaskIcon />,
  },
  {
    title: "Ec2 AutoScaling",
    subtitle: "Agente para validar metrica usuarios",
    action: "usuarios-autoscaling",
    data: [],
    type: "table",
    icon: <SwapHorizontalCircleIcon />,
  },
];

const MediaControlCard = () => {
  const [openAlert, setOpenAlert] = useState(false);
  // Función para manejar la apertura del modal de alertas de discos
  // Función para cerrar el modal
  const handleCloseAlert = () => setOpenAlert(false);

  const [open, setOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    description: "",
    data: [],
    type: "line",
  });
  const [loading, setLoading] = useState(true);

  const handleOpen = async (card) => {
    setOpen(true);
    //setLoading(true);

    // Set initial modal content before fetching data
    setModalContent({ title: card.title, description: card.subtitle, data: [], type: card.type });

    if (card.title === "Agentes EC2") {
      setModalContent({ ...card, data: [] }); // O puedes pasar datos directamente si los tienes
      setLoading(false);
      return;
    }
    let dtHoy0Horas = new Date();
    dtHoy0Horas.setHours(0);
    dtHoy0Horas.setMinutes(0);
    dtHoy0Horas.setSeconds(0, 0);
    let currentTime = dtHoy0Horas.getTime() / 1000 - 5 * 24 * 60 * 60; // Last 5 days in seconds

    // Function to fetch card data based on action
    const fetchCardData = async () => {
      try {
        // Request payload containing the action for the selected card
        const requestPayload = { action: card.action };
        const respData = await fetchData(url, context, requestPayload);
        console.log("respData....", respData);
        if (respData && respData.rows) {
          let parsedData = [];
          // Format data based on the card title
          switch (card.title) {
            case "extraccion-faltantes":
              parsedData = respData.rows.map((item) => ({
                cuenta: item.cuenta,
                instance_id: item.instance_id,
                instance_name: item.instance_name,
                ip_privada: item.ip_privada,
                ip_publica: item.ip_publica,
                producto_serialized: item.producto_serialized,
              }));
              break;
            case "Concurrencia DB":
              parsedData = respData.rows.map((item) => ({
                nombre_db: item.nombre_db,
                max_concurrencia: item.max_concurrencia,
                fecha: item.fecha,
              }));
              break;
            // case "Agentes EC2":
            //   parsedData = respData.rows.map((item) => ({
            //     cuenta: item.cuenta,
            //     instance_id: item.instance_id,
            //     instance_name: item.instance_name,
            //     producto: item.producto,
            //     estado: item.estado,
            //     aws_ec2_cpu_ram: item.aws_ec2_cpu_ram,
            //     aws_ec2_usuarios: item.aws_ec2_usuarios,
            //     aws_ec2_monitor_servicios: item.aws_ec2_monitor_servicios,
            //     aws_ec2_signal_monitor_servicios: item.aws_ec2_signal_monitor_servicios,
            //   }));
            //   break;
            case "Ec2 AutoScaling":
              parsedData = respData.rows.map((item) => ({
                account: item.account,
                cliente: item.cliente,
                instance_id: item.instance_id,
                principal: item.principal,
                estado_asg: item.estado_asg,
                estado_ec2: item.estado_ec2,
                total_usuarios: item.total_usuarios,
                tiene_usuario: item.tiene_usuario,
              }));
              break;
            default:
              console.error(`No data format found for card: ${card.title}`);
          }
          return parsedData;
        } else {
          console.error(`Invalid data received for ${card.title}`);
          return [];
        }
      } catch (error) {
        console.error(`Error fetching data for ${card.title}:`, error);
        return [];
      }
    };

    const data = await fetchCardData();
    setModalContent({ ...card, data: Array.isArray(data) ? data : [] });

    setLoading(false);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2}>
        <Grid container spacing={3}>
          {initialCardData.map((card, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <MDBox>
                <ComplexStatisticsCard
                  color="dark"
                  icon={card.icon}
                  title={card.title}
                  description={card.subtitle}
                  count={
                    <MDTypography
                      variant="h6"
                      component="a"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOpen(card);
                      }}
                      sx={{
                        color: "dark",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "bold",
                        Padding: "5px",
                      }}
                    >
                      {`Con agente: 20 - Sin agente: 5`}
                    </MDTypography>
                  }
                  percentage={{
                    color: "success",
                    label: card.subtitle,
                  }}
                />
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-end",
        }}
      >
        <Card
          sx={{
            marginTop: "20px",
            width: "86%",
            height: "96%",
            maxHeight: "100vh",
            maxWidth: "100vw",
            overflowY: "auto",
            boxShadow: 24,
          }}
        >
          <MDBox px={4} py={2} display="flex" flexDirection="column" justifyContent="space-between">
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDTypography variant="h4" color="dark">
                {modalContent.title}
              </MDTypography>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  color: theme.palette.common.dark,
                })}
              >
                <CloseIcon />
              </IconButton>
            </MDBox>

            <MDTypography id="modal-description" variant="h6" color="text" mb={2}>
              {modalContent.description}
            </MDTypography>

            <MDBox
              sx={{
                flex: 4,
                maxHeight: "calc(80vh - 200px)", // Deja espacio para el header y el padding
              }}
            >
              {modalContent.title === "extraccion-faltantes" && (
                <ViewClientes data={modalContent.data} />
              )}
              {modalContent.title === "Ec2 AutoScaling" && (
                <ViewAutoScaling data={modalContent.data} />
              )}
              {/* {modalContent.title === "Concurrencia DB" && (
                <ViewConcurrencia data={modalContent.data} />
              )} */}
              {modalContent.title === "Agentes EC2" && <ViewEc2Agentes />}
            </MDBox>
          </MDBox>
        </Card>
      </Modal>
    </DashboardLayout>
  );
};

export default MediaControlCard;
